<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Navigation Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
              v-if="user && user.IDStB"
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">{{ title }}</h1>
              <div class="text-caption grey--text font-weight-medium">Consulta y gestiona tus horarios académicos</div>
            </div>
           </div>
           
           <div class="d-none d-md-flex">
              <v-chip color="primary" class="font-weight-black px-4" label outlined>
                 <v-icon left small>mdi-calendar-clock</v-icon> PRÓXIMOS TURNOS
              </v-chip>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row no-gutters>
          <!-- Sidebar (Hidden if everything is okay, but useful for status) -->
          <v-col cols="12" md="3" v-if="user.alumno_mora || user.borrado == '1'" class="pa-6 border-right">
             <div v-if="user.alumno_mora" class="mb-6">
                <v-alert
                  border="left"
                  colored-border
                  type="warning"
                  elevation="2"
                  class="rounded-xl elite-alert"
                >
                  <div class="font-weight-black mb-1">DEUDA PENDIENTE</div>
                  <div class="text-caption">Debe abonar su deuda antes de realizar gestiones.</div>
                  <v-btn small block color="warning" class="mt-3 rounded-lg font-weight-bold shadow-glow-warning" @click="$router.push({name: 'pagos'})">Ir a Pagos</v-btn>
                </v-alert>
             </div>

             <div v-if="user.borrado == '1'">
                <v-alert
                  border="left"
                  colored-border
                  type="error"
                  elevation="2"
                  class="rounded-xl elite-alert"
                >
                  <div class="font-weight-black mb-1">USUARIO DADO DE BAJA</div>
                  <div class="text-caption">La acción no es posible de realizar en su estado actual.</div>
                </v-alert>
             </div>
          </v-col>

          <!-- Main Content: Calendar -->
          <v-col cols="12" :md="(user.alumno_mora || user.borrado == '1') ? 9 : 12" class="pa-6 bg-soft-grey min-vh-detail">
            
            <div class="glass-card-heavy rounded-xl pa-0 overflow-hidden shadow-soft-elite border">
               <FullCalendar
                class="demo-app-calendar elite-full-calendar"
                :options="calendarOptions"
                ref="calendar"
              >
                <template v-slot:eventContent="arg">
                  <div class="elite-event-pill px-2 py-1">
                    <div class="text-tiny font-weight-black line-height-1">{{ arg.timeText }}</div>
                    <div class="text-tiny elite-event-title font-weight-medium text-truncate">{{ arg.event.title }}</div>
                  </div>
                </template>
              </FullCalendar>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
    
    <!-- Modern Dialog for Booking -->
    <v-dialog v-model="dialog" persistent max-width="600px" overlay-color="#0f172a" overlay-opacity="0.9">
      <v-card class="rounded-xl overflow-hidden glass-card-interactive">
        <v-card-title class="primary white--text pa-8">
           <v-icon left color="white" large>mdi-calendar-check</v-icon>
           <div class="prism-heading text-h5 font-weight-black">Reservar Turno</div>
           <v-spacer></v-spacer>
           <v-btn icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        
        <v-card-text class="pa-8 pt-10">
           <v-row>
             <v-col cols="12">
                <div class="elite-info-strip pa-4 rounded-xl mb-6">
                   <div class="text-center">
                      <v-icon color="primary" class="mb-2">mdi-information-outline</v-icon>
                      <div class="text-body-2 font-weight-bold grey--text">Por favor indique el motivo del turno para ayudarnos a prepararnos adecuadamente.</div>
                   </div>
                </div>
                <v-textarea
                  v-model="texto"
                  outlined
                  label="Motivo del turno"
                  placeholder="Ej: Entrega de documentación física..."
                  class="elite-input rounded-xl"
                  rows="4"
                  hide-details
                ></v-textarea>
             </v-col>
           </v-row>
        </v-card-text>

        <v-card-actions class="pa-8 pt-0 d-flex justify-end">
           <v-btn text large color="grey darken-1" class="rounded-xl px-6 mr-4" @click="dialog = false">CANCELAR</v-btn>
           <v-btn color="primary" x-large class="rounded-xl px-12 font-weight-black shadow-glow" @click="apartar">CONFIRMAR TURNO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Route from "../../config/RouteApi";
import esLocale from "@fullcalendar/core/locales/es";
import moment from "moment";

moment.locale("es");

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    FullCalendar,
  },

  data: function() {
    return {
      title: "Gestión de Horarios",
      sede: { text: "", value: "" },
      sedes: [],
      tipo: { text: "DNI", value: 1 },
      documento: "",
      tipos: [
        { text: "DNI", value: 1 },
        { text: "PASAPORTE", value: 2 },
      ],
      editable: true,
      dialog: false,
      texto: "",
      turno_id: "",
      calendarOptions: {
        weekends: true,
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "timeGridDay", 
        headerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "title",
          right: "prev,next",
        },
        height: "auto",
        aspectRatio: 1.8,
        locale: esLocale,
        eventClick: this.handleEventClick,
        events: "",
        slotMinTime: "07:00:00",  
        slotMaxTime: "24:00:00",  
        allDaySlot: false,
        expandRows: true,
        slotEventOverlap: false,
        handleWindowResize: true,
        windowResizeDelay: 100
      },
    };
  },
  computed: {
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    isSmallScreen: {
      handler(newVal) {
        if (this.$refs.calendar) {
           let calendarApi = this.$refs.calendar.getApi();
           calendarApi.changeView(newVal ? "timeGridDay" : "timeGridWeek");
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$API
      .get({
        url: "sedes",
        data: {},
      })
      .then((res) => {
        this.sedes = res;
        if (this.sedes && this.sedes.length > 0) {
           this.sede.value = this.sedes[this.sedes.length - 1].value;
           this.loadData();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps;
      if (datos.link && datos.link !== '') {
        window.open(datos.link, '_blank');
      }
      console.log("Event Clicked Data:", datos);
    },

    async loadData() {
      if (this.user && this.user.IDStB) {
        this.calendarOptions.events = Route + `horario/${this.user.IDStB}`;
      }
    },
    
    async apartar() {
      if (this.texto.trim() == "") {
        alert("Debe colocar un motivo para el turno");
        return;
      }

      let dataSend = {
        text: this.texto,
        turno_id: this.turno_id,
        documento: this.documento,
        tipoDocumento: this.tipo.value,
        alumno_id: this.user.IDStB,
      };

      let url = "turno-presencial/inscribirTurno";

      await this.$API
        .post({
          url: url,
          data: dataSend,
        })
        .then(() => {
          this.texto = "";
          this.turno_id = 0;
          this.dialog = false;

          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.refetchEvents();
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }
.bg-soft-grey { background: #f8fafc; }
.border-right { border-right: 1px solid rgba(0,0,0,0.05) !important; }

/* Elite Alert Style */
.elite-alert {
  border-width: 0 0 0 6px !important;
}

/* Glass Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}
.shadow-soft-elite {
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03) !important;
}

/* FullCalendar Professional Styling */
.elite-full-calendar {
  padding: 1rem;
  background: white;
}

::v-deep .fc .fc-toolbar-title {
  font-family: "Outfit", sans-serif !important;
  font-weight: 900;
  color: #0F172A;
  font-size: 1.5rem !important;
}

::v-deep .fc .fc-button {
  background: #f1f5f9 !important;
  border: none !important;
  color: #64748b !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  font-size: 0.75rem !important;
  border-radius: 12px !important;
  padding: 8px 16px !important;
  transition: all 0.2s ease !important;
  margin: 0 2px !important;
}

::v-deep .fc .fc-button-active {
  background: #E50050 !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(229, 0, 80, 0.25) !important;
}

::v-deep .fc .fc-button:hover:not(.fc-button-active) {
  background: #e2e8f0 !important;
  color: #0F172A !important;
}

::v-deep .fc td, ::v-deep .fc th {
  border-color: #f1f5f9 !important;
}

::v-deep .fc-timegrid-slot:hover {
  background-color: rgba(26, 35, 126, 0.02) !important;
  cursor: pointer;
}

::v-deep .fc .fc-col-header-cell-cushion {
  font-family: "Outfit", sans-serif;
  color: #64748b;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 800;
  padding: 12px 4px !important;
}

::v-deep .fc .fc-timegrid-slot-label-cushion {
  font-size: 0.75rem;
  color: #94a3b8;
  font-weight: 600;
}

::v-deep .fc-v-event {
  background-color: rgba(229, 0, 80, 0.08) !important;
  border: 1px solid rgba(229, 0, 80, 0.2) !important;
  border-left: 4px solid #E50050 !important;
  border-radius: 8px !important;
}

::v-deep .fc .fc-day-today {
  background-color: rgba(26, 35, 126, 0.03) !important;
}

::v-deep .fc .fc-timegrid-now-indicator-line {
  border-color: #E50050 !important;
  border-width: 2px !important;
}

::v-deep .fc .fc-timegrid-now-indicator-arrow {
  border-color: #E50050 !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

.elite-event-pill {
  color: #9D172F;
}

.elite-event-title {
  font-size: 0.7rem;
}

/* Modals & Inputs */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1) !important;
}

.elite-input ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  border-radius: 16px !important;
}

.elite-info-strip {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(229, 0, 80, 0.3) !important;
}

.shadow-glow-warning {
  box-shadow: 0 10px 20px -5px rgba(255, 152, 0, 0.3) !important;
}

.text-tiny { font-size: 0.7rem !important; }
.line-height-1 { line-height: 1.2; }
.min-vh-detail { min-height: 80vh; }

/* Responsive adjustments */
@media (max-width: 960px) {
  .border-right { border-right: none !important; border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
  ::v-deep .fc .fc-toolbar {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
